<template>
    <v-dialog v-model="show" max-width="450" persistent no-click-animation>
        <div class="ConfirmDeleteAllDictionary">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('deleteCustomer') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!-- Dialog body -->
            <div class="dialog-content">
                <div class="mb-8">{{ $f.tc('confirmDelete', {item: $f.tc('entireDictionary').toLowerCase()}) }}</div>
            </div>
            <!--Dialog footer-->
            <div class="dialog-footer">
                <div class="btn-outline btn-delete mr-8" @click="deleteAllDictionary">
                    {{ $f.tc('delete') }}
                </div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>

import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "ConfirmDeleteAllDictionary",
    mixins: [DialogPromiseMixin, FormMixin],
    props: {
        filter: Object,
    },
    data() {
        return {
            scenario_id: '',
        }
    },
    methods: {
        open(scenario) {
            this.show = true
            this.scenario_id = scenario
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.promise.resolve()
            this.$emit('close')
        },
        deleteAllDictionary() {
            this.$appService.showLoading()
            ScenarioService.deleteAllDictionary(this.scenario_id).then(
                () => {
                    this.close()
                    this.$appService.toastSuccess(this.$f.tc('actionSuccessful', {
                        action: this.$t('delete'),
                        item: this.$t('dictionary')
                    }))
                }
            ).finally(this.$appService.hideLoading)
        },
    }
}
</script>

<style scoped lang="scss">
.ConfirmDeleteAllDictionary {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-left: 8px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .text-upload {
        font-size: 14px;
        padding: 12px;
    }

    .btn-delete {
        background: #dc3545 !important;
        color: #FFFFFF !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #dc3545bf !important;
            border: 1px solid #dc354500 !important;
        }
    }

    .btn-outline-delete {
        color: #dc3545 !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #ffabb3 !important;
            color: #dc3545 !important;
            //border: 1px solid #dc354500 !important;
        }
    }
}
::v-deep {
    .v-input--selection-controls {
        padding-top: 0 !important;
    }

    .v-input--selection-controls__ripple {
        display: none;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
    }

    .v-input--selection-controls.v-input .v-label {
        font-family: "open sans" !important;
        font-size: 14px !important;
        color: #2c3e50 !important;
    }
}
</style>
